import { z, ZodTypeAny } from "zod";

/** ------------------------------------------------------------------
 *  makePageSchema
 *  A _runtime_ helper that returns a Zod schema for cursor pages.
 * ------------------------------------------------------------------ */
export const makePageSchema = <S extends ZodTypeAny>(itemSchema: S) =>
  z
    .object({
      data: z.array(itemSchema),
      next_cursor: z.string().nullable(),
      prev_cursor: z.string().nullable().optional(),
      pageInfo: z
        .object({
          // rows that exist **before** the first row in `data` (0-based)
          offset: z.number().int().nonnegative(),
          // total rows that matched the query (after filters)
          total: z.number().int().nonnegative(),
        })
        .optional(),
    })
    .passthrough();

/** ------------------------------------------------------------------
 *  CursorPage<T>
 *  A simple _compile-time_ helper for the inferred data shape.
 * ------------------------------------------------------------------ */
export type CursorPage<T> = z.infer<ReturnType<typeof makePageSchema<z.ZodType<T>>>>;

export const PageQuerySchema = z.object({
  limit: z.coerce.number().int().positive().max(200).default(20),
  cursor: z.string().optional(),
  dir: z.enum(["next", "prev"]).default("next"),
});
export type PageQuery = z.infer<typeof PageQuerySchema>;
